import React, { useState } from "react";
import { Link } from "react-router-dom";

const MenuTables = ({ menu, serviceId, categoryId, mainRoute }) => {
  const [hoveredItemId, setHoveredItemId] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const service = menu?.find((item) => item.id == serviceId);
  const category = service?.category.find((cat) => cat.id == categoryId);

  const [activeTab, setActiveTab] = useState(0);
  if (!service || !category) return null;

  const calculateSavings = (item) => {
    if (item.discount) {
      return (((item.price - item.discountPrice) / item.price) * 100).toFixed(0);
    }
    return "0";
  };

  const displayPrice = (item) => {
    if (item.price === 0) return "FREE";
    return item.discount ? `$${item.discountPrice.toFixed(2)}` : `$${item.price.toFixed(2)}`;
  };

  const displayOriginalPrice = (item) => {
    if (item.discount) return `$${item.price.toFixed(2)}`;
    return null;
  };

  return (
    <div className="space-y-10">
      {/* <h2 className="text-2xl font-bold mb-4 text-center">
        {service.name} - {category.name}
      </h2> */}

      {/* Centered Tabs */}
      <div className="flex justify-center border-b">
        {category.subcategory.map((subcategory, index) => (
          <button
            key={subcategory.id}
            className={`py-2 px-4 ${
              activeTab === index ? "border-b-4 border-pink-300 font-bold" : ""
            }`}
            onClick={() => setActiveTab(index)}
          >
            {subcategory.name}{" "}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      {category.subcategory.map((subcategory, index) => (
        <div key={subcategory.id} className={`${activeTab === index ? "block" : "hidden"}`}>
          {/* <h3 className="text-xl font-semibold mb-4 text-center">{subcategory.name}</h3> */}
          <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-2">
            {subcategory?.menuItem
              ?.sort((a, b) => a.quantity - b.quantity)
              .map((menuItem) => (
                <div
                  key={menuItem.id}
                  className={`border rounded p-4 text-center cursor-pointer transition-all duration-200 ${
                    menuItem.promotion ? "bg-red-100" : ""
                  } ${hoveredItemId === menuItem.id ? "bg-pink-200" : ""} ${
                    selectedItem === menuItem ? "ring-2 ring-purple-500" : ""
                  }`}
                  onMouseEnter={() => setHoveredItemId(menuItem.id)}
                  onMouseLeave={() => setHoveredItemId(null)}
                  onClick={() => setSelectedItem(menuItem)}
                >
                  <div className="font-bold text-2xl">
                    {new Intl.NumberFormat().format(menuItem.quantity)}
                  </div>
                  <span
                    className={`text-xl p-2 mt-2 ${
                      menuItem.discount ? "text-pink-500 font-bold text-2xl" : ""
                    } `}
                  >
                    {displayPrice(menuItem)}{" "}
                  </span>
                  {menuItem.discount && (
                    <span className="text-md text-gray-500 line-through p-2">
                      {displayOriginalPrice(menuItem)}
                    </span>
                  )}
                  {menuItem.discount && (
                    <div className="text-md text-green-600 mt-1">
                      Save {calculateSavings(menuItem)}%
                    </div>
                  )}
                  {menuItem.promotion && (
                    <div className="text-sm text-orange-600 font-bold mt-1">PROMOTION</div>
                  )}
                </div>
              ))}
          </div>
          {selectedItem && (
            <div className="mt-10 text-center ">
              <div>
                <span className="px-2 text-3xl font-bold">{displayPrice(selectedItem)}</span>{" "}
                <span className="px-2 text-gray-500 text-xl line-through relative -top-[3px]">
                  {displayOriginalPrice(selectedItem)}
                </span>
              </div>
              {selectedItem.discount && (
                <div className="text-xl text-purple-600 mt-1">
                  You Save ${(selectedItem.price - selectedItem.discountPrice).toFixed(2)}
                </div>
              )}
              <Link
                reloadDocument
                to={`${mainRoute}/${subcategory.id}/${selectedItem.id}/${subcategory.itemId}`}
                className="mt-4 bg-pink-400 text-white px-16 py-3 rounded-full text-lg font-semibold inline-block"
              >
                {selectedItem.price === 0 ? "GET NOW" : "BUY NOW"}
              </Link>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default MenuTables;
